import { formatSIMC, relativeTime } from './format.js';

const TILES = [
  { key: 'totalPayments', label: 'Pagamentos totais' },
  { key: 'totalVolume', label: 'Volume total SIMC' },
  { key: 'activeAgents', label: 'Agentes ativos' },
  { key: 'lastPaymentAt', label: 'Último pagamento' },
  { key: 'supply', label: 'Supply' },
];

export function createStats(container) {
  container.innerHTML = TILES.map(
    (t) => `
      <div class="stat-tile">
        <div class="stat-tile__value tabular-nums" data-key="${t.key}">—</div>
        <div class="stat-tile__label">${t.label}</div>
      </div>
    `,
  ).join('');

  function render(store) {
    const s = store.stats;
    container.querySelector('[data-key="totalPayments"]').textContent = s.totalPayments.toLocaleString(
      'pt-BR',
    );
    container.querySelector('[data-key="totalVolume"]').textContent = formatSIMC(s.totalVolume, {
      maxFrac: 2,
    });
    container.querySelector('[data-key="activeAgents"]').textContent = s.activeAgents.toLocaleString(
      'pt-BR',
    );
    container.querySelector('[data-key="lastPaymentAt"]').textContent = relativeTime(s.lastPaymentAt);
    container.querySelector('[data-key="supply"]').textContent =
      s.supply != null ? `${formatSIMC(s.supply, { maxFrac: 0 })}` : '—';
  }

  return { render };
}
